export interface IStorageContentModel {
    storageContentId: number;
    storageContentUrl: string;
    container: string;
    fileName: string;
    sasToken: string | undefined;
}
export class StorageContentModel implements IStorageContentModel {
    storageContentId: number;
    storageContentUrl: string;
    container: string;
    fileName: string;
    sasToken: string | undefined;

    constructor(params: Partial<IStorageContentModel> = {} as IStorageContentModel) {
        const {
            storageContentId = 0,
            storageContentUrl = "",
            container = "",
            fileName = "",
            sasToken = undefined
        } = params;

        this.storageContentId = storageContentId;
        this.storageContentUrl = storageContentUrl;
        this.container = container;
        this.fileName = fileName;
        this.sasToken = sasToken;
    }
}
